module.exports = __webpack_public_path__ + "static/cosyelephant3-993862a5ca10488974f2366c2e1c01aa.png";